import { Rectangle } from "./Rectangle";
import { Circle } from "./Circle";
import { Distance } from "./Distance";



export class Intersects {
    //-------------------------------------------------------------------------
    /**
     * Checks if two Rectangles intersect.
     * A Rectangle intersects another Rectangle if any part of its bounds is within the other Rectangle's bounds. As such, the two Rectangles are considered "solid". A Rectangle with no width or no height will never intersect another Rectangle.
     * @param rectA 
     * @param rectB 
     * @returns `true` if the two Rectangles intersect, otherwise `false`.
     */
    //-------------------------------------------------------------------------
    static RectangleToRectangle(rectA: Rectangle, rectB: Rectangle): boolean {
        if (rectA.width <= 0 || rectA.height <= 0 || rectB.width <= 0 || rectB.height <= 0) {
            return false;
        }

        return !(rectA.right < rectB.x || rectA.bottom < rectB.y || rectA.x > rectB.right || rectA.y > rectB.bottom);
    }

    //-------------------------------------------------------------------------
    /**
     * Checks for intersection between a circle and a rectangle.
     * @param circle 
     * @param rect
     * @returns `true` if the two objects intersect, otherwise `false`.
     */
    //-------------------------------------------------------------------------
    static CircleToRectable(circle: Circle, rect: Rectangle): boolean {
        var halfWidth = rect.width / 2;
        var halfHeight = rect.height / 2;

        var cx = Math.abs(circle.x - rect.x - halfWidth);
        var cy = Math.abs(circle.y - rect.y - halfHeight);
        var xDist = halfWidth + circle.radius;
        var yDist = halfHeight + circle.radius;

        if (cx > xDist || cy > yDist) {
            return false;
        }
        else if (cx <= halfWidth || cy <= halfHeight) {
            return true;
        }
        else {
            var xCornerDist = cx - halfWidth;
            var yCornerDist = cy - halfHeight;
            var xCornerDistSq = xCornerDist * xCornerDist;
            var yCornerDistSq = yCornerDist * yCornerDist;
            var maxCornerDistSq = circle.radius * circle.radius;

            return (xCornerDistSq + yCornerDistSq <= maxCornerDistSq);
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Checks if two Circles intersect.
     * @param circleA 
     * @param circleB 
     */
    //-------------------------------------------------------------------------
    static CircleToCircle(circleA: Circle, circleB: Circle): boolean {
        return (Distance.Between(circleA.x, circleA.y, circleB.x, circleB.y) <= (circleA.radius + circleB.radius));
    }
}